import { PortalError } from './PortalError';

export class NoMeasurementsReportError extends PortalError {
  constructor() {
    super('NoMeasurementsReportError', 'No measurements in report date range', 'create_report_no_reports');
  }
}
